// Keeps a marquee's scroll speed constant regardless of how many items it holds.
// Markup carries the item count (data-marquee) and seconds-per-item (data-per-logo);
// the animation-duration is derived from them so the per-item speed stays fixed.
export default function initMarquee() {
  const marquees = document.querySelectorAll("[data-marquee]")

  marquees.forEach((el) => {
    const count = parseInt(el.dataset.marquee, 10)
    const perItem = parseFloat(el.dataset.perLogo)

    if (!count || !perItem) return

    el.style.animationDuration = `${count * perItem}s`

    // Hold the animation until the logo images have loaded — otherwise the
    // track width shifts mid-run and the -50% loop jumps / leaves gaps.
    const pending = Array.from(el.querySelectorAll("img")).filter((img) => !img.complete)
    if (pending.length === 0) return

    el.style.animationPlayState = "paused"
    let remaining = pending.length
    const onReady = () => {
      remaining -= 1
      if (remaining === 0) el.style.animationPlayState = ""
    }
    pending.forEach((img) => {
      img.addEventListener("load", onReady, { once: true })
      img.addEventListener("error", onReady, { once: true })
    })
  })
}
